import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Navigation from 'vue-navigation'
import Vconsole from 'vconsole';
Vue.use(Navigation, {router})
import './util/install'
Vue.config.productionTip = false
// if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent) && process.env.VUE_APP_ENV !== 'development') {
  // new Vconsole();
// }
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
